import { render, staticRenderFns } from "./ideaSpecsPreview.vue?vue&type=template&id=26f09d08&scoped=true"
import script from "./ideaSpecsPreview.vue?vue&type=script&lang=js"
export * from "./ideaSpecsPreview.vue?vue&type=script&lang=js"
import style0 from "./ideaSpecsPreview.vue?vue&type=style&index=0&id=26f09d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f09d08",
  null
  
)

export default component.exports